import {
  Datatype,
  ReferenceType,
  type IReference,
  type IReferencePath,
} from '@framework/engine';
import type { IElectoralListChooserWidget } from './IElectoralListChooserWidget';

/**
 * Riferimento del widget: la lista elettorale selezionata. Esponiamo le liste
 * configurate come opzioni così che le espressioni possano confrontare il valore
 * con i singoli id lista. Il candidato scelto resta un dato interno del voto e
 * non viene esposto come riferimento.
 */
export function getElectoralListChooserReference(
  path: IReferencePath,
  widget: IElectoralListChooserWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.String,
      // `label` = id lista: il nome lista non è disponibile in questa funzione
      // pura (richiederebbe una fetch); l'id basta per il confronto nelle
      // espressioni, dove l'autore conosce gli id che ha configurato.
      options: (widget.electoralListIds ?? []).map(id => ({
        value: id,
        label: id,
      })),
    },
  };
}
